// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fPfl","productName":"Table_productName__3fPRf"};